<template>
    <v-app>
        <header-card-public ref="refHeader" current_page="contact-us"></header-card-public>
        <v-content class="content-container">
            <v-layout fill-height align-center row wrap>
                <v-flex xs12 sm12 :class="isMobile?'form-container-mobile':'form-container'">
                    <v-card class="elevation-1" style="border-radius:4px;">
                        <v-toolbar flat height="45px">
                            <h3>CONTACT US</h3>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="text-xs-left">
                            <div style="margin:0px 15px 0px 25px;">
                                <p>We value your feedback, inquiries, and suggestions. Please feel free to reach out to us using the following contact information:</p>
                                <b>Customer Support</b>
                                <p>If you have any questions, concerns, or need assistance, our dedicated customer support team is here to help. You can reach us by email or cellphone during our business hours.</p>
                                <ul>
                                    <li class="subheading">Email: <span @click="OpenEmailWindow('mailto:support@sweldonow.ph')" class="link">support@sweldonow.ph</span></li>
                                    <li class="subheading">Cellphone: +63 922 234 0858</li>
                                </ul><br>
                                <b>Sales Inquiries</b>
                                <p>For business-related inquiries, including requesting a product demo, quote or any other business-related matters, please contact our sales team. We look forward to discussing potential opportunities with you:</p>
                                <ul>
                                    <li class="subheading">Email: <span @click="OpenEmailWindow('mailto:sales@sweldonow.ph')" class="link">sales@sweldonow.ph</span></li>
                                </ul><br>
                                <b>Billing Inquiries</b>
                                <p>For any questions or issues related to billing, invoices, or payment methods, please contact our billing department:</p>
                                <ul>
                                    <li class="subheading">Email: <span @click="OpenEmailWindow('mailto:billing@sweldonow.ph')" class="link">billing@sweldonow.ph</span></li>
                                </ul>
                            </div>
                        </v-card-text>
                    </v-card>    
                </v-flex>
            </v-layout>
        </v-content>

        <!-- FOOTER -->
        <v-footer dark height="auto">
            <footer-card></footer-card>
        </v-footer>
    </v-app>
</template>
<script>

import '@/assets/css/public-FaceAI.css' 

export default {
    name: 'ContactUs',
    metaInfo: {
        title: 'ContactUs',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: '' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'header-card-public': () => import('@/components/HeaderPublic'),
        'footer-card': () => import('@/components/Footer'),
    },
    data () {
        return {
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
         }
    },
    methods: {
        closeDialog() {
            this.$emit('update:dialogContactUs', false)
        },
        OpenEmailWindow(url) {
            window.open(url, '_blank')
        },
    },
}
</script>
<style scoped>
.content-container {
    background: 
        linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, rgba(173, 216, 230, 0.25) 100%),
        url("../assets/landing/landing8.jpg");
    height:auto;
    min-height:600px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.form-container {
    margin: 80px 100px 50px 100px;
}
.form-container-mobile {
    margin: 110px 20px 50px 20px;
}
.content1 {
    padding: 0px 20px 0px 20px;
}
.content2 {
    padding: 0px 25px 0px 15px;
}
.content-mobile {
    padding: 0px 25px 0px 20px;
}
.header-intro {
    margin:5px 15px 15px 25px;
}
</style>